import { render, staticRenderFns } from "./GateControl.vue?vue&type=template&id=247fd5ec&scoped=true&"
import script from "./GateControl.vue?vue&type=script&lang=js&"
export * from "./GateControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fd5ec",
  null
  
)

export default component.exports